package br.com.texeratx.boardgametimeapp.domain.usecases.login

import br.com.texeratx.boardgametimeapp.data.repository.LoginRepository

class ForgotPasswordUseCase(
    private val repository: LoginRepository
) {
    suspend operator fun invoke(email: String): Result<String> {
        return try {
            val response = repository.forgotPassword(email)
            Result.success(response.message)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
